





























import { Watch, Component, Prop, Vue, Inject } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { OrderAPI, ReferralAPI } from '@/api/backend-client'
import { namespace } from 'vuex-class'
import { Order } from '@/api/model/order'
const referrals = namespace('referrals')

@Component
export default class DeleteReferralModal extends Vue {
    @referrals.State readonly view!: string
    @referrals.State readonly direction!: string
    @referrals.Action applyView!: ({ view: ReferralView, direction: ReferralFilterDirection }) => Promise<void>
    @Prop({ required: true }) readonly referral!: Referral
    @Prop({ type: Boolean, default: false }) value!: boolean

    orders: Order[] = []
    visible: boolean = false
    loading: boolean = false

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    async fetchOrders(): Promise<void> {
        this.orders = await OrderAPI.getAll({
            referral: this.referral.id,
        })
    }

    async deleteReferral(): Promise<void> {
        this.loading = true

        try {
            await this.fetchOrders()
            await ReferralAPI.delete(this.referral.id)
            this.$notify({
                type: 'success',
                text: this.$t('referral.deleteSuccess').toString(),
            })

            // Reload referral list and navigate back to lister.
            await this.applyView({ view: this.view, direction: this.direction })
            await this.$router.push({name: 'tasks_all'})

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: error.message,
            })
        }

        this.loading = false

        this.$emit('on-save', true)
    }

    get hasOrders(): boolean {
        return this.orders.length > 0
    }
}
